module.exports = __webpack_public_path__ + "img/login_icon_user.557038a.png";